import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showTournament, setShowTournament] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    let lastScroll = 0;

    const handleScroll = () => {
      const currentScroll = window.pageYOffset;
      const navbar = document.querySelector(".landing-navbar");

      if (!navbar) return;

      if (currentScroll > lastScroll) {
        navbar.style.transform = "translateY(-100%)";
      } else {
        navbar.style.transform = "translateY(0)";
      }

      lastScroll = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) {
        setMenuOpen(false);  // auto close mobile menu on desktop
        setShowTournament(false); // also close submenu
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* NAVBAR */}

      <nav className="landing-navbar">

        {/* LOGO LEFT */}
        <div className="landing-logo" onClick={() => navigate("/")}>
          <img src="/Images/AATTUM-Logo.png" alt="KPL Logo" />
        </div>

        {/* DESKTOP MENU */}
        <ul className="landing-menu desktop-only">
          <li className={location.pathname === "/" ? "active" : ""} onClick={() => navigate("/")}>Home</li>

          <li className={location.pathname === "/about-tpl" ? "active" : ""} onClick={() => navigate("/about-tpl")}>About</li>

          <li className="dropdown31">
            <span className="dropdown-title31">Tournaments</span>

            <ul className="dropdown-menu31">
              <li className="dropdown-parent31">
                <span className="dropdown-heading31">Current Event</span>
                <ul className="sub-menu31">
                  <li onClick={() => navigate("/cricket-homepage")}>Women's T20 Premier League</li>
                </ul>
              </li>

              <hr className="dropdown-divider31" />

              <li className="dropdown-parent31">
                <span className="dropdown-heading31">Upcoming Events</span>
                <ul className="sub-menu31">
                  <li onClick={() => navigate("/Eventhomepage")}>Men's T20 Premium League</li>
                </ul>
              </li>
            </ul>
          </li>
          {/* <li className={location.pathname === "/sponsor" ? "active" : ""} onClick={() => navigate("/sponsor")}>Sponsors</li> */}
          <li className={location.pathname === "/blogs" ? "active" : ""} onClick={() => navigate("/blogs")}>Blogs</li>
          <li className={location.pathname === "/AtplGallery" ? "active" : ""} onClick={() => navigate("/AtplGallery")}>Gallery</li>
          <li className={location.pathname === "/contact-us" ? "active" : ""} onClick={() => navigate("/contact-us")}>Contact Us</li>
        </ul>

        {/* REGISTER BUTTON – DESKTOP */}
        <button className="landing-login-btn desktop-only" onClick={() => navigate("/register")}>
          <span>Register Now</span>
        </button>

        {/* MOBILE RIGHT SECTION */}
        <div className="mobile-right mobile-only">

          {/* Mobile Register Button */}
          <button className="mobile-top-register" onClick={() => navigate("/register")}>
            Register
          </button>

          {/* Hamburger Icon */}
          <div className="hamburger" onClick={() => setMenuOpen(true)}>
            <div></div><div></div><div></div>
          </div>

        </div>

      </nav>


      {/* MOBILE SLIDE MENU */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="mobile-menu-header">
          <span className="close-btn" onClick={() => setMenuOpen(false)}>&times;</span>
        </div>

        <ul>
          <li
            className={location.pathname === "/" ? "active" : ""}
            onClick={() => { navigate("/"); setMenuOpen(false); }}
          >
            Home
          </li>

          <li
            className={location.pathname === "/about-tpl" ? "active" : ""}
            onClick={() => { navigate("/about-tpl"); setMenuOpen(false); }}
          >
            About
          </li>

          {/* MOBILE DROPDOWN FOR TOURNAMENT */}
          <li className="mobile-dropdown">
            <span
              className={(location.pathname === "/cricket-homepage" || location.pathname === "/Eventhomepage") ? "active" : ""}
              onClick={() => setShowTournament(!showTournament)}
            >
              Tournaments
            </span>

            <ul className={`mobile-submenu ${showTournament ? "open" : ""}`}>
              <li className="submenu-title">Current Event</li>

              <li
                className={location.pathname === "/cricket-homepage" ? "active" : ""}
                onClick={() => { navigate("/cricket-homepage"); setMenuOpen(false); }}
              >
                Women's T20 Premier League
              </li>

              <li className="submenu-title">Upcoming Events</li>

              <li
                className={location.pathname === "/Eventhomepage" ? "active" : ""}
                onClick={() => { navigate("/Eventhomepage"); setMenuOpen(false); }}
              >
                Men's T20 Premium League
              </li>
            </ul>
          </li>
          <li
            className={location.pathname === "/sponsor" ? "active" : ""}
            onClick={() => { navigate("/sponsor"); setMenuOpen(false); }}
          >
            Sponsors
          </li>
          <li
            className={location.pathname === "/AtplGallery" ? "active" : ""}
            onClick={() => { navigate("/AtplGallery"); setMenuOpen(false); }}
          >
            Gallery
          </li>
          <li
            className={location.pathname === "/blogs" ? "active" : ""}
            onClick={() => { navigate("/blogs"); setMenuOpen(false); }}
          >
            Blogs
          </li>

          <li
            className={location.pathname === "/contact-us" ? "active" : ""}
            onClick={() => { navigate("/contact-us"); setMenuOpen(false); }}
          >
            Contact Us
          </li>
        </ul>

      </div>

    </>
  );
};

export default Navbar;
